/**
 * utilProvider
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

const _noop = () => {
    // No-op
};

export function utilProvider() {
    function $get($mdUtil, $injector, $q) {
        const $state = $injector.has('$state') ? $injector.get('$state') : null;

        return {
            nextTick: function (callback: (...args: any[]) => void = _noop, immediate?) {
                if (immediate) {
                    $mdUtil.nextTick(callback);
                } else {
                    // Return a wrapper around the callback
                    return function (...args) {
                        $mdUtil.nextTick(() => {
                            callback.apply(null, [...args]);
                        });
                    };
                }
            },

            nextTickImmediate: function (callback?) {
                return this.nextTick(callback, true);
            },

            go: function ($event, state, params = {}, options?) {
                if ($event && $event.metaKey) {
                    window.open($state.href(state, params, options));
                    return $q.resolve();
                } else {
                    return $state.go(state, params, options);
                }
            },

            open: function (url: string, target: string | MouseEvent = '_self') {
                if (target instanceof MouseEvent) {
                    target = target.metaKey
                        ? '_blank'
                        : '_self';
                }

                window.open(url, target);
            },
        };
    }

    $get.$inject = ['$mdUtil', '$injector', '$q'];

    this.$get = $get;
}
